import { Routes, Route, Navigate } from 'react-router-dom';
import PartnerReferralsOverview from './PartnerReferralsOverview';
import TrackInvites from './TrackInvites';
import { Entity } from '../../../../../types/apiTypes';

interface PartnerReferralsProps {
  userType: string;
  currentPage: string;
  currentTab: string;
  setCurrentTab: (tab: string) => void;
  subTab: string;
  setSubTab: (tab: string) => void;
}

function PartnerReferrals({
  userType,
  currentPage,
  currentTab,
  setCurrentTab,
  subTab,
  setSubTab,
}: PartnerReferralsProps) {
  const props = {
    userType,
    currentPage,
    currentTab,
    setCurrentTab,
    subTab,
    setSubTab,
  };
  return (
    <Routes>
      <Route path="/" element={<Navigate to="overview" replace />} />
      <Route
        path="/overview"
        element={<PartnerReferralsOverview {...props} />}
      />
      {/* Only show track-invites route for parent Partner accounts, not PartnerAgent */}
      {userType === Entity.Partner && (
        <Route path="/track-invites" element={<TrackInvites {...props} />} />
      )}
    </Routes>
  );
}

export default PartnerReferrals;
